
export default {
  props: {
    height: {
      type: String,
      default: '600px'
    },
    hascountdown: {
      type: String,
      default: ''
    }
  },
  mounted() {
    // const txt = this.$v('{0}秒后返回首页').replace('{0}', (count < 0 ? 0 : count))
    // this.$refs.cutdownMsg.innerText = txt
    // let count = 5
    // const timer = setInterval(() => {
    //   const txt = this.$v('{0}秒后返回首页').replace('{0}', (count < 0 ? 0 : count))
    //   this.$refs.cutdownMsg.innerText = txt
    //   if (count <= 0) {
    //     this.tolink()
    //   }
    //   count--
    // }, 1000)
    // this.$once('hook:beforeDestroy', () => { // 销毁定时器
    //   clearInterval(timer)
    // })
  },
  methods: {
    tolink() {
      // 跳转
      window.open(`https://www.${this.$store.state.newhost}.${this.getSuffix(this.$store.state)}/${this.$store.state.LanguageCode}/`)
    }
  }
}
